import Lenis from 'lenis';

const lenis = new Lenis({
	duration: 1.2,
	easing: t => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // https://www.desmos.com/calculator/brs54l4xou
	touchMultiplier: 2,
	prevent: node =>
		node.classList.contains('wpcf7-textarea') ||
		node.tagName.toLowerCase() === 'textarea' ||
		node.classList.contains('var_dump_modal'),
});

function raf(time) {
	lenis.raf(time);
	requestAnimationFrame(raf);
}

requestAnimationFrame(raf);

const stopSmoothScroll = lenis => lenis.stop();
const startSmoothScroll = lenis => lenis.start();

export { lenis, stopSmoothScroll, startSmoothScroll };
